import { UserModel } from '@core/services/api.service';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, Inject, ViewChild , OnChanges} from '@angular/core';
import { DataSourceConfig } from '@core/models';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { UsersState } from '@ngxs-store/users-store/users.state';
import { Observable } from 'rxjs';
import { LoadUsersAction } from '@ngxs-store/users-store/users.actions';
import { AssignUserAction } from '@ngxs-store/managed-tour-store/managed-tour.actions';

@Component({
  selector: 'app-assign-user-dialog',
  templateUrl: './assign-user-dialog.component.html',
})
export class AssignUserDialogComponent implements OnInit, OnChanges {
    @Select(UsersState.getUsers) users$: Observable<UserModel[]>;
    @Input() users: UserModel[];
    @Input() isLoading: boolean;
    @Input() isMobileMode: boolean;
    @Input() id: number;
    @Output() updateDataSourceConfig = new EventEmitter<DataSourceConfig>();
    @Output() dataSourceConfigChanged = new EventEmitter<DataSourceConfig>();
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    dataSource: MatTableDataSource<UserModel>;
    dataSourceConfig$: Observable<DataSourceConfig>;

    dataSourceConfig: DataSourceConfig = {
        name: 'users-table',
        columns: ['username',
        'firstname',
        'lastname',
        'email',
        'actions'],
        desktopModeColumns: [],
        mobileModeColumns: ['username', 'email', 'actions'],
        pageIndex: 10,
        pageSize: 10,
        pageSizeOptions: [10, 50, 100],
        filter: '',
        filterColumns: ['username', 'createdBy'],
        selectedFilterColumns: ['username'],
        sortBy: '',
        sortByOrder: ''
    };

  constructor(private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any,
    private store: Store) {
    this.store.dispatch(new LoadUsersAction());
    this.id = data.id;
    this.dataSource = new MatTableDataSource(this.users);
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = (data: UserModel, filter: string) => this.filterPredicate(data, filter);

    this.users$.subscribe(users => {
      this.users = users;
      this.dataSource.data = users;
    });

    this.applyDataSourceConfig();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.users && changes.users.currentValue) {
      const users: UserModel[] = changes.tourList.currentValue as UserModel[];
      this.dataSource.data = users;
    }

    if (changes.dataSourceConfig) {
      this.applyDataSourceConfig();
    }
  }


  onCancelClick(): void {
    this.dialogRef.closeAll() ;
  }

  applyDataSourceConfig() {
    if (this.dataSource.paginator) {
      this.dataSource.filter = this.dataSourceConfig.filter;
      this.dataSource.paginator.pageIndex = this.dataSourceConfig.pageIndex;
      this.dataSource.paginator.pageSize = this.dataSourceConfig.pageSize;
      this.dataSource.paginator.pageSizeOptions = this.dataSourceConfig.pageSizeOptions;
    }

    if (this.dataSource.sort) {
      this.dataSource.sort.direction = this.dataSourceConfig.sortByOrder;
      this.dataSource.sort.active = this.dataSourceConfig.sortBy;
    }
  }

  page(pageEvent: PageEvent) {
    this.updateDataSourceConfig.emit({ ...this.dataSourceConfig, pageIndex: pageEvent.pageIndex, pageSize: pageEvent.pageSize });
  }

  sortChange(sortEvent: Sort) {
    this.updateDataSourceConfig.emit({ ...this.dataSourceConfig, sortByOrder: sortEvent.direction, sortBy: sortEvent.active });
  }

  assign(selectedUser: UserModel) {
    if (selectedUser) {
      this.store.dispatch(new AssignUserAction(this.id, selectedUser.id));
      this.dialogRef.closeAll();
    }
  }


  filterPredicate(data: UserModel, filter: string): boolean {
    if (this.dataSourceConfig.selectedFilterColumns.length > 0) {
      return this.dataSourceConfig.selectedFilterColumns.length === 1
        ? data[this.dataSourceConfig.selectedFilterColumns[0]].toString().toLowerCase().includes(filter.trim().toLowerCase())
        : this.dataSourceConfig.selectedFilterColumns
          .reduce((prevVal, currVal, idx) => {
            return idx === 1 ? data[prevVal] + data[currVal] : prevVal + data[currVal];
          })
          .toString()
          .toLowerCase()
          .includes(filter.trim().toLowerCase());
    }
  }
}
